/**
 * Core product page script. Defines `<product-main>` and its supporting custom elements.
 * Orchestrates variant selection, URL and DOM updates on variant change, media sliders,
 * selling plans, bundle pricing, and interactive state capture/restore across page transitions.
 */
if(!customElements.get('product-main')) {
  class ProductMain extends HTMLElement {
    static instanceCount = 0;

    updateRefs() {
      this.variantsElement = this.querySelector('product-variants,product-high-variants');
      this.sellingPlanElement = this.querySelector('product-selling-plan');
      this.quantityElement = this.querySelector('.quantity-input.is-main-input');
      this.badgesSale = this.querySelectorAll('.badge.sale');
      this.badgesSoldOut = this.querySelectorAll('.badge.sold-out');
      this.badgesVariantUnavailable = this.querySelectorAll('.badge.variant-unavailable');
      this.variantTitleElements = this.querySelectorAll('[data-variant-title]');
    }

    updateProductData(newProductJsonData) {
      // Update productData from the JSON in the DOM (needed after morph/replace when product changes)
      this.productData = newProductJsonData;
      this.fillProductData();

      // Update requiredOptions
      const requiredOptionsSetting = ([] || []).concat(this.dataset.manualSelect ? this.dataset.manualSelect.split(',') : []).map(x=>x.trim());
      const requiredOptionsSettingUnique = [...new Set(requiredOptionsSetting)];
      this.requiredOptions = this.productData.options_with_values.filter(x=>(requiredOptionsSettingUnique.indexOf(x.name)>-1 || requiredOptionsSettingUnique.indexOf('*')>-1) && x.values.length>1).map(x=>x.name);

      if (this.requiredOptions.length > 0) {
        this.setAttribute('data-required', 'true');
      } else {
        this.removeAttribute('data-required');
      }
    }

    constructor() {
      super();
      this.sectionId = this.dataset.section + '-' + ProductMain.instanceCount++; // for Unique product component IDs
      const productJsonElement = this.querySelector('[type="application/json"][data-product-json]');
      const productJsonData = JSON.parse(productJsonElement.textContent);
      this.updateProductData(productJsonData);
      this.fillProductData();
      this.updateRefs();
      this.optionValues = {}
      if (this.quantityElement) {
        this.quantityElement.addEventListener('change', this.onQuantityElementChange.bind(this));
      }
      this.addEventListener('variantChange', this.onVariantChange.bind(this));

      

    }

    fillProductData() {
      const isMerge = this.productData.is_product_merge;
      this.productData.options_with_values.forEach(option=>{
        option.values = option.values.map(x=>{
          // Normalize Shopify option values (string or object) to the shape used by this script.
          const normalizedValue = (typeof x === 'object' && x !== null)
            ? (x.value ?? x.name ?? `${x}`)
            : x;
          return {
            ...(typeof x === 'object' && x !== null ? x : {}),
            value: normalizedValue,
            available: (typeof x === 'object' && x !== null && typeof x.available !== 'undefined') ? x.available : true
          }; //availability calculated by filtered variants in getOptionValues function
        });
      });if (this.productData.is_product_main) {
        let altPerProduct = {}
        this.productData.media = Array.from(this.querySelectorAll('product-gallery [data-media-id]')).map((media)=>{
          let alt;
          if (!isMerge) {}
          return {
            "alt": alt,
            "id": media.getAttribute('data-media-id'),
            "src": media.querySelector('img').getAttribute('data-file')
          };
        });
      }

    }

    isSwatchSelected() {
      return this.requiredOptions.length == 0 || this.requiredOptions.length < this.productData.options_with_values.length;
    }

    isSwatchColorSelected() {
      const colorSwatches = this.querySelector('.product-swatch.color-swatches, .si-color-swatches');
      if (!colorSwatches || !colorSwatches.dataset || !colorSwatches.dataset.label) {
        return this.isSwatchSelected();
      }
      return this.requiredOptions.indexOf(colorSwatches.dataset.label) == -1;
    }

    required(option, newValue) {
      var ix = this.requiredOptions.indexOf(option);
      if (typeof(newValue)!='undefined') {
        if (ix > -1) {
          this.requiredOptions.splice(ix, 1);
          if (this.requiredOptions.length == 0) {
            this.setAttribute('data-required', 'false');
          }
          return false;
        }
      }
      return ix > -1;
    }

    getCurrentVariant() {
      return this.variantsElement.getCurrentVariant();
    }
    getCurrentPlan() {
      return this.sellingPlanElement?.getCurrentPlan();
    }
    getQuantity() {
      return this.quantityElement ? this.quantityElement.value : 1;
    }
    onQuantityElementChange() {
      this.dispatchEvent(new CustomEvent('quantityChange', {detail: {"quantity":this.getQuantity()}}));
    }
    onVariantChange() {
      // Lightweight update of elements that not worth creating their own components
      var variant = event.detail.variant;
      this.variantTitleElements.forEach(element=>{
        element.innerHTML = variant ? variant.title : '';
      });
      this.badgesSale.forEach(element=>{
        var sale = '';
        if (variant) {
          var percent = Math.floor((1 - variant.price / variant.compare_at_price) * 100);
          if (percent > 0) {
            sale = element.dataset.msgtpl.replace('[percent]', percent);
          }
        }
        element.style.display = variant && variant.available && sale ? '' : 'none';
        element.innerHTML = sale;
      });
      this.badgesSoldOut.forEach(element=>{
        element.style.display = variant && variant.available === false ? '' : 'none';
      });
      this.badgesVariantUnavailable.forEach(element=>{
        element.style.display = variant ? 'none' : '';
      });}}
  customElements.define('product-main', ProductMain);

  class ComponentProductCardAtc extends ProductMain {
    constructor() {
      super()
      this.swatches = this.querySelector('.swatch-group')
      this.addEventListener('variantChange', this.onVariantChange.bind(this));
      this.defaultImage = this.querySelector('.img.main').getAttribute('data-srcset');
      this.currentImageUrl = '';
      this.imageObserver = null;
      this.clickOutHandler = null;
      let imageContainer = this.querySelector('.image-container');
      if (imageContainer && imageContainer.querySelector('.hover-img')) {
        let hover = false;
        this.addEventListener('mouseleave', (e)=>{
          hover && (hover=false,imageContainer.classList.remove("hover"));
        });
        this.addEventListener('mousemove', (e)=>{
          let bounds = imageContainer.getBoundingClientRect();
          if (e.y>bounds.top && e.y<bounds.bottom && e.x>bounds.left && e.x<bounds.right) {
            hover || (hover=true,imageContainer.classList.add("hover"))
          } else {
            hover && (hover=false,imageContainer.classList.remove("hover"));
          }
        });
      }

      this.optionsButton = this.querySelector('.atc-options');
      if (this.optionsButton) {
        this.optionsButton.addEventListener('click', this.openOptions.bind(this));
        
      }


      this.quickViewBtn = this.querySelector('.quick-view-trigger')
      if(this.quickViewBtn) {
        this.quickViewBtn.addEventListener('click', this.openQuickView.bind(this));
      }

      var self = this;
      if (self.classList.contains('colors-out')) {
        setTimeout(function() { //workaround on ajax call, the following code mistakenly inits ProductSwatch before ProductVariants
          var origSwatches = self.querySelector('.product-swatch.color-swatches');
          if (origSwatches) {
            //need to duplicate the whole product-variants component
            //Note that for product-high-variants we handle in a different way, without an expandable panel.
            var pv = origSwatches.closest('product-variants');
            if (pv) {
              var tag = pv.outerHTML.replace('name="id"', '');
              var wrapper = document.createElement('div');
              wrapper.style.display = 'none';
              //must insert as Element, not HTML, otherwise the component would be reconstructed
              self.querySelector('add-to-cart-form').insertAdjacentElement('beforebegin', wrapper);
              tag = tag.replace('<product-swatch', '<product-swatch data-trim-options-limit="4"');
              wrapper.innerHTML = tag;
              //move the swatches inside the add-to-cart-form component to use existing css.
              self.querySelector('add-to-cart-form').insertAdjacentElement('afterbegin', wrapper.querySelector('product-swatch.color-swatches'));
            }
          }
        }, 10);
      }
      if (window.LinkPrefetch && window.LinkPrefetch.addHoverListener) {
        window.LinkPrefetch.addHoverListener(this);
      }
    }

    // Added to match colors on product cards loaded through ajax, probably not needed for main product sections
    copySchemeFrom(el) {
      var lookForClasses = ['scheme','color-scheme-1','color-scheme-2','color-scheme-3','color-scheme-c17d0d61-ba03-4944-8e87-3562436bfc2f','color-scheme-14d866df-afe5-4f44-a99d-deb798430aba', 'same-scheme-true', 'same-scheme-false'];
      lookForClasses.forEach(name=>{
        if (el.classList.contains(name)) {
          this.classList.add(name);
        } else {
          this.classList.remove(name);
        }
      })

    }

    openOptions(e) {
      e.preventDefault()
      const currentVariant = this.getCurrentVariant();
      if (currentVariant && currentVariant.available) {
        const inputs = this.querySelectorAll(
          'input:not([type="hidden"]):not([type="button"]):not([type="submit"]):not([type="reset"]), textarea, select'
        );
        if (inputs.length==0) {
          this.querySelector('.btn.add').click();
          return;
        }
      }

      if (this.querySelector('.atc-options-wrapper').classList.contains('open')) {
        return;
      }
      var container = this.querySelector('.atc-options-wrapper form');
      this.querySelector('.atc-options-wrapper').classList.add('open');
      $s.trapFocus(container);
      var self = this;
      if (!this.clickOutHandler) {
        this.querySelector('.close').addEventListener('click', this.closeOptions.bind(this));
      }
      this.clickOutHandler = function(evt) {
        if(container !== evt.target && !container.contains(evt.target)) {
          self.closeOptions.bind(self)();
        }
      }
      document.addEventListener('mousedown', this.clickOutHandler);
    }
    closeOptions() {
      this.querySelector('.atc-options-wrapper').classList.remove('open');
      document.removeEventListener('mousedown', this.clickOutHandler);
      $s.removeTrapFocus();
    }

    openQuickView(e) {
      e.preventDefault()
      $s.showLoadingOverlay();
      var qvUrl = this.quickViewBtn.dataset.url;
      $s.get({
        url: qvUrl,
        success: (html)=>{
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var section = doc.querySelector('.product-main-element').closest('.shopify-section');
          var enhancedDescription = section.querySelector('.enhanced-description');
          if (enhancedDescription && enhancedDescription.querySelector('.expandable-default-open')) {
            enhancedDescription.querySelector('.accordion.open').classList.remove('open');
            enhancedDescription.querySelector('[aria-expanded=true]').ariaExpanded = false;
            enhancedDescription.querySelector('.expandable-default-open').classList.remove('expandable-default-open');
          }
          $s.openModal(section, 'product-quick-view');
          $s.globalEval(section);
        },
        always: (html)=>{
          $s.hideLoadingOverlay();
        }
      })
    }

    onVariantChange(event) {
      super.onVariantChange(event);
      var variant = event.detail.variant;
      var image = variant && variant.featured_media && super.isSwatchColorSelected() ? variant.featured_media : null;
      var img = this.querySelector('.img.main');
      var width = Math.ceil(img.width / 100) * 100;
      if (image && img.classList.contains('under-video')) {
        this.querySelector('.video-wrap').remove();
        img.classList.remove('under-video');
      }

      if (img.classList.contains('lazyload')) {
        try {
          if (img.clientWidth > 0) {
            const imageUrl = image ? image.src : this.defaultImage.substr(this.defaultImage.lastIndexOf('//')).split(' ')[0];
            const replacementImg = img.cloneNode();
            $s.dynamicImageWidthFilter(replacementImg, imageUrl, img.clientWidth);
            img.insertAdjacentElement('afterend', replacementImg);
            img.remove();
          } else {
            throw new Error('img does not have clientWidth, use fallback option');
          }
        } catch (e) {
          // original implementation with lazysizes left as fallback, but has a noticeable delay when replacing the card html (high variants product card use case).
          img.setAttribute('data-srcset', image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage);
          lazySizes.loader.unveil(img);
        }
      } else {
        this.currentImageUrl = image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage;
        if (!this.imageObserver) {
          if (!img.classList.contains('lazyloaded')) {
            this.imageObserver = new MutationObserver(mutations => {
              if (img.classList.contains('lazyloaded')) {
                this.imageObserver.disconnect();
                this.imageObserver = null;
                img.setAttribute('srcset', this.currentImageUrl);
              }
            });
            var config = { attributes: true, attributeFilter: ['class']};
            this.imageObserver.observe(img, config);
          } else {
            img.setAttribute('srcset', this.currentImageUrl);
          }
        }
      }

      // Update urls to variant
      var links = this.querySelectorAll('.product-card-url[href]');
      if (links.length > 0 && this.requiredOptions.length < this.productData.options_with_values.length) {
        var productUrl = new URL(links[0].getAttribute('href'), location.origin);
        productUrl.searchParams.set('variant', variant.id);
        links.forEach(link=>{
          link.setAttribute('href', productUrl.toString());
        });
        if (this.quickViewBtn) {
          this.quickViewBtn.dataset.url = productUrl.toString();
        }
      }
    }
  }
  customElements.define('product-card-atc', ComponentProductCardAtc);
}

if(!customElements.get('product-buttons')) {
  class ProductButtons extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.dynamicButtons = this.querySelector('.shopify-payment-button');
      this.mainAddButton = this.mainElement.querySelector('.btn.add');
      this.button = this.querySelector('.btn.add');
      if (this.button != this.mainAddButton) {
        this.button.addEventListener('click', (event)=>{
          event.preventDefault();
          event.stopImmediatePropagation();
          this.mainAddButton.click();
        });
      }

      // Keep a stable reference to the handler so it can be deregistered in disconnectedCallback
      this._boundButtonsVisibility = this._boundButtonsVisibility || this.buttonsVisibility.bind(this);
    }
    connectedCallback() {
      try {
        this.buttonsVisibility();
      } catch (e) {
      }
      this.mainElement.addEventListener('variantChange', this._boundButtonsVisibility);
    }

    disconnectedCallback() {
      if (this.mainElement && this._boundButtonsVisibility) {
        this.mainElement.removeEventListener('variantChange', this._boundButtonsVisibility);
      }
    }

    buttonsVisibility() {
      const variant = this.mainElement.getCurrentVariant();
      var requiredBtn = this.querySelector('.btn.selection-required');
      if (this.required() && requiredBtn) {
        if (this.dynamicButtons) {
          this.dynamicButtons.classList.add('hide');
        }
        requiredBtn.style.display = '';
        requiredBtn.innerHTML = this.requiredMessage;
      } else if(variant && variant.available) {
        if (this.dynamicButtons) {
          this.dynamicButtons.classList.remove('hide');
        }
        this.querySelector('.btn.add').style.display = '';
        this.querySelector('.sold-out-message').style.display = 'none';
        if (requiredBtn) requiredBtn.style.display = 'none';
      } else {
        if (this.dynamicButtons) {
          this.dynamicButtons.classList.add('hide');
        }
        this.querySelector('.btn.add').style.display = 'none';
        const btn = this.querySelector('.sold-out-message');
        if (variant) {
          btn.innerHTML = lngg.product_main__sold_out_message;
        } else {
          btn.innerHTML = lngg.product_main__unavailable_message;
        }
        btn.style.display = '';
        if (requiredBtn) requiredBtn.style.display = 'none';
      }
    }

    required() {
      if (this.mainElement.requiredOptions.length > 0) {
        this.requiredMessage = '';
        var label = this.mainElement.requiredOptions[0];
        var firstLetter = label[0].toLowerCase();
        var prep = 'aeiou'.indexOf(firstLetter)>-1 ? 'an' : 'a'; //english support only
        this.requiredMessage = lngg.product_main__select_option_label.replace('Select a ', 'Select ' + prep + ' ').replace(new RegExp(/{{ *option_name *}}/), label);
        return true;
      }
      return false;
    }
  }
  customElements.define('product-buttons', ProductButtons);
}

if(!customElements.get('product-sku')) {
  class ProductSKU extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this._boundOnVariantChange = this._boundOnVariantChange || this.onVariantChange.bind(this);
    }

    connectedCallback() {
      if (this.mainElement && this._boundOnVariantChange) {
        this.mainElement.addEventListener('variantChange', this._boundOnVariantChange);
      }
    }

    disconnectedCallback() {
      if (this.mainElement && this._boundOnVariantChange) {
        this.mainElement.removeEventListener('variantChange', this._boundOnVariantChange);
      }
    }

    onVariantChange(e) {
      if(e.detail.variant) {
        if(e.detail.variant.sku) {
          this.closest('.module').style.display = 'block';
          this.innerHTML = e.detail.variant.sku;
        }else{
          this.closest('.module').style.display = 'none';
        }
      }
    }
  }
  customElements.define('product-sku', ProductSKU);
}

if(!customElements.get('product-gallery') && !customElements.get('product-thumbs')) {
  class ProductMedia extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.itemsWrapper = this.querySelector('.items-wrapper');
      this.desktopStyle = this.dataset.desktop;
      this.desktopOrientation = this.dataset.desktopOrientation;
      this.mobileStyle = this.dataset.mobile;
      this.slider = false;
      this._boundOnVariantChange = this._boundOnVariantChange || this.onVariantChange.bind(this);
      this._boundOnMediaChange = this._boundOnMediaChange || this.onMediaChange.bind(this);
    }

    connectedCallback() {
      if (this.mainElement && this._boundOnVariantChange) {
        this.mainElement.addEventListener('variantChange', this._boundOnVariantChange);
      }
      if (this._boundOnMediaChange) {
        window.addEventListener('mediaChange', this._boundOnMediaChange);
      }
      setTimeout(()=>{
        this.onMediaChange();
      }, 10);
    }

    disconnectedCallback() {
      if (this.mainElement && this._boundOnVariantChange) {
        this.mainElement.removeEventListener('variantChange', this._boundOnVariantChange);
      }
      if (this._boundOnMediaChange) {
        window.removeEventListener('mediaChange', this._boundOnMediaChange);
      }
    }

    filterMedia(variant) {
      this.mainElement.productData.media.forEach((media)=>{
        var show = true;
        if (this.dataset.filterImageName === 'true') {
          var optionIndex = this.mainElement.productData.options_with_values.findIndex(x => x.name == this.dataset.filterImageNameBy);
          if(optionIndex>=0) {
            var found = false;
            if(media.src.toLowerCase().indexOf($s.handleize(variant.options[optionIndex].toLowerCase())) > -1) {
              found = true;
            }
            show = found;
          }
        } else {
          if((media.alt && media.alt!="")) {
            var filter = media.alt.split(';');
            filter.forEach((f)=>{
              if(show) {
                var key = f.split(':')[0];
                var values = f.split(':')[1];
                var optionIndex = this.mainElement.productData.options_with_values.findIndex(x=>x.name==key.trim());
                if(optionIndex>=0 && values) {
                  var found = false;
                  values.split(',').forEach((value)=>{
                    if(variant.options[optionIndex]==value.trim()) {
                      found = true;
                    }
                  });
                  show = found;
                }
              }
            });
          }
        }
        if(show) {
          this.querySelector('[data-media-id="'+media.id+'"]').style.display = '';
        } else {
          this.querySelector('[data-media-id="'+media.id+'"]').style.display = 'none';
        }
      });
      if(this.slider) {
        this.slider.refresh();
      }
    }

    onVariantChange() {
    }

    onMediaChange() {
    }

    initSlider() {
    }

    removeSlider() {
      if(this.slider) {
        this.slider.destroy();
        this.slider = false;
        this.classList.remove('keen');
        this.itemsWrapper.classList.remove('keen-slider');
        this.querySelectorAll('.media-wrap, .thumb-wrap').forEach((slide)=>{
          slide.classList.remove('keen-slider-slide')
        });
      }
    }

    showItem(mediaId, animate=true) {
      if(this.slider) {
        var index = Array.from(this.itemsWrapper.querySelectorAll('.media-wrap, .thumb-wrap'))
          .filter(x=>$s.isVisible(x)).findIndex(x=>x.dataset.mediaId==mediaId);
        if(animate) {
          this.slider.moveToSlideRelative(index, true);
        } else {
          this.slider.moveToSlideRelative(index, true, 0);
        }
      }
    }
  }

  class ProductGallery extends ProductMedia {
    constructor() {
      super();

      this.videoAutoplay = this.dataset.videoAutoplay;
      this.autoplayOptionsElement = this.videoAutoplay ? this.querySelector('.autoplay-options') : null;
      this.autoplayCheck = this.autoplayOptionsElement ? this.autoplayOptionsElement.querySelector('input') : null;
      this.itemsPerViewMobile = this.dataset.itemsPerViewMobile ? this.dataset.itemsPerViewMobile/1 : 1;
      this.selectedMedia = null;
      if (this.autoplayCheck) {
        this.autoplayCheck.addEventListener('change', (e)=>{
          Cookies.set('autoplay', e.target.checked ? 'enabled' : 'disabled');
        });
        this.autoplayCheck.checked = Cookies.get('autoplay') !== 'disabled';
      }

      this.bindLightbox();
    }

    bindLightbox() {
      if(this.closest('.tingle-modal')) {
        return;
      }
      this.querySelectorAll('[data-file]').forEach((media)=>{
        media.addEventListener('click', (e)=>{
          var visibleItems = [];
          this.querySelectorAll('[data-media-id]').forEach((obj)=>{
            if($s.isVisible(obj)) {
              let element  = obj.querySelector('[data-file], video, iframe');
              if(element) {
                visibleItems.push(element);
              }
            }
          });
          $s.photoSwipe(visibleItems, media);
        });
      });
      this.querySelectorAll('[data-media-id].model-wrap').forEach((model)=>{
        model.addEventListener('click', (e)=>{
          $s.photoSwipe([model.querySelector('template').content.firstElementChild]);
        });
      });
    }

    async onVariantChange(e) {
      if (this.dataset.remoteLoading === 'true' && this.dataset.filterImageNameBy) {
        const optionIndex = this.mainElement.productData.options_with_values.findIndex(x => x.name == this.dataset.filterImageNameBy);
        const filterValue = $s.handleize(e.detail.variant.options[optionIndex])
        await this.loadRemoteProductImages(filterValue);
        return;
      }
      var variant = e.detail.variant;
      var animate = e.detail.animate;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant);
        if(variant.featured_media && this.mainElement.isSwatchColorSelected()) {
          this.selectedMedia = variant.featured_media;
          this.showItem(variant.featured_media.id, animate)
        }
      }
    }

    async loadRemoteProductImages(filterValue) {
      // Ignore stale responses from rapid variant changes instead of AbortController,
      // which was surfacing unhandled AbortError rejections via $s.fetch.
      const requestId = (this._remoteImagesRequestId = (this._remoteImagesRequestId || 0) + 1);

      const productUrl = (this.mainElement.dataset.productUrl || this.mainElement.productData.product_url || '')
        .split('?')[0]
        .replace(/\/$/, '');
      const jsonUrl = `${productUrl}.json`;

      try {
        const data = await $s.getJson({ url: jsonUrl });
        if (requestId !== this._remoteImagesRequestId) return;
        const images = data.product?.images || data.images || [];
        const filteredImages = images.filter(image => image.src.toLowerCase().indexOf(`color-${filterValue}`) > -1);
        this.rebuildCarousel(filteredImages);
      } catch (error) {
        if (requestId !== this._remoteImagesRequestId) return;
        console.error(error);
      }
    }

    rebuildCarousel(filteredImages) {
      const previousHeight = this.offsetHeight;
      if (previousHeight) {
        this.style.minHeight = `${previousHeight}px`;
      }

      if (this.slider) {
        this.slider.destroy();
        this.slider = false;
      }
      this.itemsWrapper.innerHTML = '';
      const dots = this.querySelector('.keen-dots');
      if (dots) {
        dots.innerHTML = '';
      }

      const productId = this.mainElement.productData.product_id;
      const isScrolling = (this.dataset.desktop || '').indexOf('scrolling') > -1;

      filteredImages.forEach((image, index) => {
        const wrap = document.createElement('div');
        wrap.className = 'image-wrap media-wrap';
        wrap.dataset.mediaId = image.id;
        wrap.dataset.mediaAlt = image.alt || '';
        wrap.dataset.productId = productId;
        if (isScrolling && image.alt && image.alt.indexOf('pdp-grid-width') > -1) {
          const flexBasis = image.alt.split('pdp-grid-width').pop().split(';')[0].replace(':', '').trim();
          if (flexBasis) {
            wrap.style.flexBasis = flexBasis;
          }
        }

        const img = document.createElement('img');
        img.src = $s.imagePlaceholder(image);
        const srcset = $s.lazySrc(image);
        if (index === 0) {
          img.setAttribute('srcset', srcset);
          img.setAttribute('fetchpriority', 'high');
        } else {
          img.setAttribute('data-srcset', srcset);
          img.classList.add('lazyload');
        }
        img.setAttribute('data-sizes', 'auto');
        img.setAttribute('data-file', image.src);
        img.setAttribute('itemprop', 'image');
        img.alt = image.alt && image.alt.indexOf(':') === -1 ? image.alt : '';
        img.width = image.width;
        img.height = image.height;
        wrap.appendChild(img);
        this.itemsWrapper.appendChild(wrap);
      });

      this.bindLightbox();
      this.style.minHeight = '';
      this.initSlider();
    }

    onMediaChange() {
      if($s.media.isSmall || this.desktopStyle=='carousel' || this.desktopStyle == 'dots') {
        this.initSlider();
        if(this.selectedMedia) {
          this.showItem(this.selectedMedia.id, false)
        }
      } else {
        this.removeSlider();
      }
    }

    initSlider() {

      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll('.media-wrap').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });

        var breakpoints = {};
        if (this.desktopStyle == 'dots') {
          breakpoints['(min-width: '+(parseInt(window.breakpoints.small) + 0.001) +'rem)'] = {
            dots: this.querySelector('.keen-dots')
          }
        }
        if(this.mobileStyle=='dots') {
          breakpoints['(max-width: '+window.breakpoints.small+')'] = {
            dots: this.querySelector('.keen-dots')
          }
        }
        if(this.mobileStyle=='carousel') {
          breakpoints['(max-width: '+window.breakpoints.small+')'] = {
            slidesPerView: this.itemsPerViewMobile
          }
        }
        const sliderOptions = {
          mode: "snap",
          loop: true,
          wheel: false,
          pageInfo: this.querySelector('.keen-slider-page'),
          slideChanged: (keen)=>{
            $s.pauseAllMedia(this);
            let canPlay = true;
            if (this.autoplayOptionsElement) {
              this.autoplayOptionsElement.classList.remove('visible');
            }
            if (this.videoAutoplay) {
              const media = keen.currentSlide().querySelector('.media');
              if (this.autoplayOptionsElement && media) { // && media is to only show the checkbox on video slides.
                this.autoplayOptionsElement.classList.add('visible');
                //TODO eval  checkbox
                this.autoplayCheck.checked = canPlay = Cookies.get('autoplay')!='disabled';
              }
              if (media && canPlay) {
                $s.playMedia(media);
              }
            }
            this.dispatchEvent(new CustomEvent('slideChanged', {detail: keen}));
          },
          breakpoints
        };

        const prevButton = this.querySelector('.keen-arrow.prev');
        const nextButton = this.querySelector('.keen-arrow.next');
        if (prevButton && nextButton) {
          sliderOptions.prevButton = prevButton;
          sliderOptions.nextButton = nextButton;
        }

        this.slider = new KeenSlider(this.itemsWrapper, sliderOptions);
      }
    }
  }
  customElements.define('product-gallery', ProductGallery);

  class ProductThumbs extends ProductMedia {
    constructor() {
      super();
      this.mainGallery = this.mainElement.querySelector('product-gallery');

      this.querySelectorAll('[data-media-id]').forEach((media)=>{
        media.addEventListener('click', (e)=>{
          this.mainGallery.showItem(media.dataset.mediaId);
        });
      });

      this.mainGallery.addEventListener('slideChanged', (e)=>{
        var currentSlide = e.detail.currentSlide();
        if(currentSlide) {
          var currentMediaId = currentSlide.dataset.mediaId;
          var currentSlideElement = this.querySelector('.current-slide');
          if(currentSlideElement) {
            currentSlideElement.classList.remove('current-slide');
          }
          this.querySelector('[data-media-id="'+currentMediaId+'"]').classList.add('current-slide');
          this.showItem(currentMediaId);
        }
      });
    }

    onVariantChange(e) {
      if (this.mainGallery?.dataset.remoteLoading === 'true') {
        return;
      }
      var variant = e.detail.variant;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant)
      }
    }

    onMediaChange() {
      if(($s.media.isSmall && this.mobileStyle.indexOf('thumbnails')>-1) || ($s.media.isMediumUp && (this.desktopStyle=='carousel') )) {
        this.style.display = 'block';
        this.initSlider();
      } else {
        this.style.display = 'none';
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll('.thumb-wrap').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });
        var breakpoints = {};
        breakpoints['(max-width: '+window.breakpoints.medium+')'] = {
          slidesPerView: 4,
          spacing: 10,
          centered: false,
          ...(this.mobileStyle=='thumbnails_vertical' ? {
            vertical: true
          } : {vertical: false})
        }
        breakpoints['(max-width: '+window.breakpoints.small+')'] = {
          slidesPerView: 5,
          spacing: 10,
          centered: false,
          ...(this.mobileStyle=='thumbnails_vertical' ? {
            vertical: true
          } : {vertical: false})
        }
        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: true,
          centered: false,
          slidesPerView: 7,
          spacing: 15,
          prevButton: this.querySelector('.keen-arrow.prev'),
          nextButton: this.querySelector('.keen-arrow.next'),
          breakpoints,
          ...(this.desktopOrientation=='vertical' ? {
            vertical: true,
            slidesPerView: 5
          } : {})
        });
      }
    }
  }
  customElements.define('product-thumbs', ProductThumbs);
}

if(!customElements.get('product-price')) {
  class ProductPrice extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.finalPriceElement = this.querySelector('.final');
      this.comparePriceElement = this.querySelector('.compare');
      this.multiplyQuantity = typeof(this.dataset.multiplyQuantity)!='undefined' ? this.dataset.multiplyQuantity=='true' : false

      if(this.mainElement.classList.contains('product-card')){
        var originalPricePrefix = '<span class="visually-hidden">'+lngg.product__original_price_label+': </span>'
        var finalPricePrefix = '<span class="visually-hidden">. '+lngg.product__final_price_label+': </span>'
      }else{
        var originalPricePrefix = '<span class="visually-hidden">'+lngg.product__original_price_label+': </span>'
        var finalPricePrefix = '<span class="visually-hidden">. '+lngg.product__final_price_label+': </span>'
      }

      this.listenEvents = ['variantChange','sellingPlanChange'];
      if (this.multiplyQuantity)
        this.listenEvents.splice(1, 0, 'quantityChange');

      this._boundOnMainEvent = this._boundOnMainEvent || ((e)=>this.onMainEvent(e, originalPricePrefix, finalPricePrefix));
    }

    connectedCallback() {
      if (!this.mainElement || !this._boundOnMainEvent) return;
      this.listenEvents.forEach((event)=>{
        this.mainElement.addEventListener(event, this._boundOnMainEvent);
      });
    }

    disconnectedCallback() {
      if (!this.mainElement || !this._boundOnMainEvent) return;
      this.listenEvents.forEach((event)=>{
        this.mainElement.removeEventListener(event, this._boundOnMainEvent);
      });
    }

    onMainEvent(e, originalPricePrefix, finalPricePrefix) {
      const data = this.mainElement.getCurrentPlan() || this.mainElement.getCurrentVariant();
      let quantity = 1;
      if (data) {
        quantity = this.multiplyQuantity ? this.mainElement.getQuantity() : 1;
        this.finalPriceElement.innerHTML = $s.formatMoney(data.price * quantity).replace('.00','');

        if(data.compare_at_price > data.price) {
          this.comparePriceElement.classList.remove('hide');
          this.comparePriceElement.innerHTML = originalPricePrefix + $s.formatMoney(data.compare_at_price * quantity).replace('.00','');
          this.finalPriceElement.innerHTML = finalPricePrefix + $s.formatMoney(data.price * quantity).replace('.00','');
        } else {
          this.comparePriceElement.classList.add('hide');
          this.comparePriceElement.innerHTML = '';
        }
      } else {
        this.finalPriceElement.innerHTML = '&nbsp;';
        this.comparePriceElement.innerHTML = '';
      }
      this.mainElement.dispatchEvent(new CustomEvent('priceChange', {detail: {price: data ? data.price * quantity : null}}));
    }
  }
  customElements.define('product-price', ProductPrice);
}

if(!customElements.get('product-variants')) {
  class ProductVariantsAbstract extends HTMLElement {
    constructor() {
      super();
      this.variantsInfo = this.dataset.info ? JSON.parse(this.dataset.info) : null;
    }

    getOptionInfo(optionName) {
      return (this.variantsInfo ? this.variantsInfo.find(x=>x.title==optionName) : null) || {};
    }

    getOptionInfoIcon(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.description) {
        html = `
          <div class="option-info-icon">
            <button type="button" class="btn-open">?</button>
            <div class="option-info-content animation">${info.description}</div>
          </div>
        `;
      }

      return html;
    }

    getOptionInfoLink(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.link_text) {
        if (info.link_target_image) {
          html = `
            <button type="button" class="option-info-link link" data-image-width="${info.link_target_image_native_width}" data-image-height="${info.link_target_image_native_height}" data-image="${info.link_target_image}" data-width="${info.link_target_image_width}">${info.link_text}</button>
          `;
        } else {
          html = `
            <a class="option-info-link link" href="${info.link_target_url}" target="_blank">${info.link_text}</a>
          `;
        }

      }

      return html;
    }

    deselectRequiredOptions() {
      const x = this.mainElement.requiredOptions;
      x.forEach((option)=>{
        //only works for options generated in liquid, custom options are handled where they get generated in javascript.
        const element = this.querySelector('product-hvswatch[data-label="'+option+'"]');
        if (!element) return;
        element.setAttribute('data-required', 'true');

        const checkbox = element.querySelector('input:checked');
        if (checkbox) {
          checkbox.checked = false;
          checkbox.setAttribute('data-selected', 'true');
        }
      })
    }

    bindInfoElements() {
      this.options.forEach((element)=>{
        var infoIcon = element.querySelector('.option-info-icon');
        var infoLink = element.querySelector('.option-info-link');
        let variantsElement = element.variantsElement || element.closest('product-variants, product-high-variants');
        if (!infoIcon) {
          let html = variantsElement.getOptionInfoIcon(element.dataset.label) || '';
          if (html) {
            element.querySelector('.option-name').insertAdjacentHTML('afterbegin', html);
            infoIcon = element.querySelector('.option-info-icon');
          }
        }
        if (!infoLink) {
          let html = variantsElement.getOptionInfoLink(element.dataset.label) || '';
          if (html) {
            element.querySelector('.option-name').insertAdjacentHTML('beforeend', html);
            infoLink = element.querySelector('button.option-info-link');
          }
        }
        if (infoIcon) {
          $s.initFloatingPanel({container: infoIcon});
        }
        if (infoLink && infoLink.tagName.toLowerCase() == 'button') {
          infoLink.addEventListener('click', (e)=>{
            var imageWidthPX = parseFloat(getComputedStyle(document.documentElement).fontSize) * infoLink.dataset.width;
            var html = `
              <div class="option-info-popup-content scheme" style="width: ${infoLink.dataset.width}rem">
                <img alt="" src="${infoLink.dataset.image + (infoLink.dataset.image.indexOf('?')==-1 ? '?' : '&') + 'width='+imageWidthPX}" width="${infoLink.dataset.imageWidth}" height="${infoLink.dataset.imageHeight}" />
              </div>
            `;
            $s.openModal(html, 'option-info-popup');
          });
        }
      });
    }

  }

  class ProductVariants extends ProductVariantsAbstract {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.mainElement.variantsInstances = (this.mainElement.variantsInstances || 0) +1;
      this.instanceIndex = this.mainElement.variantsInstances;
      this.variantInput = this.querySelector('[data-variant-id]');
      this.options = this.querySelectorAll('[data-option]');
      this.swatchImg = this.querySelector('product-swatch[data-use-img="true"]');
      this.mainElement.addEventListener('variantChange', (event)=> {
        if (this.variantInput.value != event.detail.variant.id) {
          this.setVariant(event.detail.variant);
        }
      })

      this.bindOptions();
      setTimeout(()=>{
        this.variantChange(this.getCurrentVariant(), false);
        this.bindInfoElements();
      }, 10);
    }

    getCurrentVariant() {
      return this.mainElement.productData.variants.find(x=>x.id==this.variantInput.value)
    }

    setVariant(variant) {
      if(typeof variant !== 'object') {
        variant = this.mainElement.productData.variants.find(x=>x.id==variant);
      }
      if(variant) {
        this.refreshOptions(-1, variant);
        this.variantChange(variant);
      }
    }

    variantChange(variant, animate=true) {
      if(variant) {
        this.variantInput.value = variant.id;
        
          if (this.mainElement.productData.is_product_main && !this.mainElement.closest('.tingle-modal')) {
            var url = new URL(location.href);
            url.searchParams.set('variant', variant.id);
            if (variant.product_url) {
              url.pathname = variant.product_url.split('?')[0];
            }
            history.replaceState({},'', url.toString());
          }
        
      } else {
        this.variantInput.value = '';
      }
      this.previousVariant = variant;
      this.variantInput.dispatchEvent(new Event('change', {bubbles: true}));
      this.mainElement.dispatchEvent(new CustomEvent('variantChange', {detail: {variant, animate}}));

      if (this.swatchImg) {
          //var variant = this.mainElement.productData.variants.
          var optionIndex = this.swatchImg.dataset.option/1 -1;
          this.swatchImg.querySelectorAll('[type="radio"]').forEach(radio=>{
            var label = radio.parentNode.querySelector('.label-inner');

            var matchingVariant = this.mainElement.productData.variants.find(v => {
              if (v.options[optionIndex] !== radio.value) return false;
              // All other options must match the current variant
              for (let i = 0; i < v.options.length; i++) {
                if (i === optionIndex) continue;
                if (v.options[i] !== variant.options[i]) return false;
              }
              return true;
            });
            if (!matchingVariant) {
              matchingVariant = this.mainElement.productData.variants.find(
                v => v.options[optionIndex] == radio.value
              );
            }
            let img = label.querySelector('img');
            if (matchingVariant.featured_media) {
              if (!img) {
                img = document.createElement('img');
                img.loading = 'lazy';
                img.width = 80;
                img.height = 80;
                img.alt = '';
                label.appendChild(img);
              }
              img.src = $s.imgUrlFilter(matchingVariant.featured_media.src, '80x');
              img.style.display = '';
            } else {
              if (img) {
                img.style.display = 'none';
              }
            }
          });

      }

    }

    calculateNewVariant(optionChanged, value) {
      var newVariants = this.mainElement.productData.variants;
      this.mainElement.productData.options_with_values.forEach((option, index)=>{
        if(optionChanged==index) {
          newVariants = newVariants.filter(x=>x.options[index]==value);
        } else {
          var tmpNewVariants = this.previousVariant ? newVariants.filter(x=>x.options[index]==this.previousVariant.options[index]) : [];
          if(tmpNewVariants.length==0) {
            tmpNewVariants = newVariants.filter(x=>x.options[index]==newVariants[0].options[index]);
          }
          newVariants = tmpNewVariants;
        }
      });
      return newVariants[0];
    }

    bindOptions() {
      this.options.forEach((element)=>{
        element.addEventListener('change', (e)=>{
          let optionIdx = element.dataset.option-1;
          let variant = this.calculateNewVariant(optionIdx, e.target.value);
          this.refreshOptions(element.dataset.option-1, variant);
          this.variantChange(variant);
        });
      });
    }

    // Get values with availability that depends on previous options
    getOptionValues(currentVariant) {
      var options = [];
      var variants = this.mainElement.productData.variants;
      options = structuredClone(this.mainElement.productData.options_with_values.map(x=>x.values));
      options.forEach((values, index) => {
        // Filter variants that match previous selections
        let filteredVariants = variants;
        for (let prev = 0; prev < index; prev++) {
          filteredVariants = filteredVariants.filter(
            v => v.options[prev] === currentVariant.options[prev]
          );
        }
        let retValues = [];
        values.forEach((valueObj) => {
          const matchingVariants = filteredVariants.filter(
            v => v.options[index] === valueObj.value
          );
          if (matchingVariants.length > 0) {
            valueObj.available = matchingVariants.some(v => v.available);
            retValues.push(valueObj);
          }
        })
        options[index] = retValues;
      });
      return options;
    }

    refreshOptions(updateOptionIndex=-1, currentVariant) {
      var optionValues = this.getOptionValues(currentVariant);
      this.options.forEach((element)=>{
        let index = element.dataset.option - 1;
        if(index > updateOptionIndex) {
          element.buildOptions(optionValues[index], currentVariant.options[index]);
        }
        var optionValueElement = element.querySelector('.option-value');
        if(optionValueElement) {
          optionValueElement.innerHTML = currentVariant.options[index];
        }
      });
    }
  }
  customElements.define('product-variants', ProductVariants);

  class ProductHighVariants extends ProductVariantsAbstract {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.currentValues = this.getSelectedValues();
      this.variantInput = this.querySelector('[data-variant-id]');
      this.addEventListener('change', this.onVariantChange.bind(this));
      this.mainElement.dispatchEvent(new CustomEvent('variantChange', {detail: {variant: this.getCurrentVariant()}}));
      this.options = this.querySelectorAll('[data-option]');
      this.deselectRequiredOptions();
      this.bindInfoElements();
    }

    getCurrentVariant() {
      return this.mainElement.productData.variants.find(x=>x.id==this.variantInput.value)
    }

    onVariantChange(e) {
      let productChanged = false;
      const fieldLabel = e.target.closest('product-hvswatch, product-hvdropdown').dataset.label;
      this.focusSelector = '[data-label="'+fieldLabel+'"] input[value="'+e.target.value+'"], [data-label="'+fieldLabel+'"] select';
      this.productUrl = this.mainElement.dataset.productUrl;
      if (this.mainElement.required(fieldLabel)) {
        this.mainElement.required(fieldLabel, false); //remove option from required fields
      }
      if (e.target.dataset.productUrl) {
        this.productUrl = e.target.dataset.productUrl;
        productChanged = true;
      } else if (e.target.tagName == 'SELECT' && e.target.options[e.target.selectedIndex].dataset.productUrl) {
        this.productUrl = e.target.options[e.target.selectedIndex].dataset.productUrl;
        productChanged = true;
      }
      //get all selected input values inside the component
      let values = this.getSelectedValues();
      if (!productChanged && this.currentValues == values) {
        this.mainElement.dispatchEvent(new CustomEvent('variantChange', {detail: {variant: this.mainElement.getCurrentVariant()}}));
        return;
      }
      this.currentValues = values;

      this.updateProductHtml(values, productChanged, e.target.dataset.variantid);
    }

    getSelectedValues() {
      let inputs = this.querySelectorAll('product-hvswatch input:checked, product-hvdropdown select, input.hidden-option-value');
      let values = [];
      inputs.forEach(input=>{
        if(input.tagName=='INPUT') {
          values.push(input.value);
        } else if(input.tagName=='SELECT') {
          values.push(input.value);
        }
      });
      return values.join(',');
    }

    setValues(values) {
      this.productUrl = this.mainElement.dataset.productUrl;
      this.currentValues = values;
      this.updateProductHtml(values)
    }

    updateProductHtml(values, productChanged, variantid) {
      // Always capture state before making changes, so we can restore it even when switching products
      let urlObj = new URL(this.productUrl, window.location.origin);
      urlObj.searchParams.set('option_values', values);
      if (productChanged && variantid) {
        urlObj.searchParams.set('variant', variantid);
        urlObj.searchParams.delete('option_values');
      }
      const isPDP = this.mainElement.productData.is_product_main;
      const isCurrentPDP = isPDP && location.href.indexOf('/products/') > -1 && this.mainElement === document.querySelector('.product-main-element') && this.closest('.tingle-modal') == null;
      const loadOnlyProductMainSection = isPDP && !productChanged;
      const currentSectionElement = this.mainElement.closest('.shopify-section');
      const currentSectionId = currentSectionElement?.id ? currentSectionElement.id.replace(/^shopify-section-/, '') : null;
      if (!isPDP) {
        urlObj.searchParams.set('section_id', 'product_card_ajax');
      } else if(loadOnlyProductMainSection) {
        // Use the actual section instance id (template--...__product_main), not the section type id.
        urlObj.searchParams.set('section_id', currentSectionId || 'product_main');
      }
      const getUrl = urlObj.toString().replaceAll('%2C', ',');

      if (self.requestController) {
        self.requestController.abort();
      }
      self.requestController = new AbortController();
      const bodyHadAnimationSpeed0 = document.body.classList.contains('animation-speed-0');

      this.productRequest = $s.get({
        url: getUrl,
        signal: self.requestController.signal,
        success: async (data)=>{
          const savedScrollY = isCurrentPDP ? window.scrollY : null;
          if (isCurrentPDP) {
            this.mainElement.dataset.replacingInfo = 'true';
          }
          if (!bodyHadAnimationSpeed0) {
            document.body.classList.add('animation-speed-0');
          }
          let mainElement;
          let newDom = new DOMParser().parseFromString(data, 'text/html');

          const newMainElement = newDom.querySelector('.product-main-element');

          const previousState = this.captureInteractiveState();

          if (isCurrentPDP && !loadOnlyProductMainSection) {
            //replace other template sections that don't contain shopify-app-block
            //main section is updated more carefully after this
            await (async ()=>{
              const ignoreAppBlocks = true;
              let currentSections = Array.from(this.closest('main').querySelectorAll('.shopify-section'));
              let newSections = Array.from(newDom.querySelectorAll('main .shopify-section'));
              let newMainDom = newDom.querySelector('main');
              currentSections.forEach((section, index)=>{
                if (ignoreAppBlocks && section.querySelector('.shopify-app-block')) {
                  return;
                }
                if (section.contains(this.mainElement)) {
                  return;
                }
                const newSectionMatch = newMainDom.querySelector('.shopify-section[id="'+section.id+'"]');
                if (!newSectionMatch) {
                  section.remove();
                }
              });
              let lastSectionAdded = null;
              for (let index = 0; index < newSections.length; index++) {
                let section = newSections[index];
                if (section.contains(newMainElement)) {
                  lastSectionAdded = this.mainElement.closest('.shopify-section');
                  continue;
                }
                const currentSection = currentSections.find(x => x.id == section.id);
                if (currentSection) {
                  const parent = currentSection.parentNode;
                  currentSection.outerHTML = section.outerHTML;
                  const updatedSection = parent.querySelector(`#${section.id}`);
                  lastSectionAdded = updatedSection;
                  await $s.globalEval(lastSectionAdded);
                  continue;
                }

                if (lastSectionAdded) {
                  lastSectionAdded.insertAdjacentHTML('afterend', section.outerHTML);
                  lastSectionAdded = lastSectionAdded.nextElementSibling;
                } else {
                  const currentMainDom = this.closest('main');
                  currentMainDom.insertAdjacentHTML('afterbegin', section.outerHTML);
                  lastSectionAdded = currentMainDom.firstElementChild;
                }
                await $s.globalEval(lastSectionAdded);

              }
            })();

          }

          if (productChanged || !isPDP) {
            // Combined listing: product changed
            const currentMainElement = this.mainElement;
            this.mainElement.innerHTML = '';
            newMainElement.requiredOptions = currentMainElement.requiredOptions;
            this.mainElement.insertAdjacentElement('beforebegin', newMainElement);
            this.mainElement.remove();
            mainElement = newMainElement;
            $s.globalEval(mainElement);
          } else {
            // Same product, different variant: replace info block
            const newProductJsonElement = newDom.querySelector('[type="application/json"][data-product-json]');
            const newProductJsonData = JSON.parse(newProductJsonElement.textContent);
            const newInfo = newDom.querySelector('.main-product-info');
            const currentInfo = this.mainElement.querySelector('.main-product-info');
            const scrollAnchorContainer = this.mainElement.closest('main') || document.documentElement;
            const previousOverflowAnchor = scrollAnchorContainer.style.overflowAnchor;
            scrollAnchorContainer.style.overflowAnchor = 'none';
            // Update product data before compomonents get created.
            this.mainElement.updateProductData(newProductJsonData);

            // Keep the same DOM node to reduce sticky/scroll recalculations.
            currentInfo.innerHTML = newInfo.innerHTML;
            $s.globalEval(currentInfo);
            requestAnimationFrame(() => {
              scrollAnchorContainer.style.overflowAnchor = previousOverflowAnchor;
            });

            mainElement = this.mainElement;
            mainElement.updateRefs();

          }

          //mainElement is now the new instance

          // Restore interactive state for both same-product and cross-product changes
          this.restoreInteractiveState(mainElement, previousState);
          mainElement.dispatchEvent(new CustomEvent('variantChange', {detail: {variant: mainElement.getCurrentVariant()}}));

          // Original focus logic for same-product variant changes
          const targetFocusElement = mainElement.variantsElement?.querySelector(this.focusSelector);
          if (this.focusSelector && targetFocusElement && targetFocusElement !== document.activeElement) {
            try {
              targetFocusElement.focus({ preventScroll: true });
            } catch (e) {
              targetFocusElement.focus();
            }
          }

          //update browser url when seeing the PDP of the same product that was updated.
          if (isCurrentPDP) {
            const browserUrl = new URL(getUrl, window.location.origin);
            browserUrl.searchParams.delete('section_id');
            history.replaceState(null, null, browserUrl.href.replaceAll('%2C', ','));
          }

          if (savedScrollY !== null) {
            window.scrollTo(0, savedScrollY);
            requestAnimationFrame(() => window.scrollTo(0, savedScrollY));
          }
          if (isCurrentPDP) {
            requestAnimationFrame(() => {
              delete this.mainElement.dataset.replacingInfo;
            });
          }

          if (!bodyHadAnimationSpeed0) {
            document.body.classList.remove('animation-speed-0');
          }

          mainElement.dispatchEvent(new CustomEvent('sectionsUpdateFinished'))

        }
        ,
        error: ()=>{
          if (isCurrentPDP) {
            delete this.mainElement.dataset.replacingInfo;
          }
          if (!bodyHadAnimationSpeed0) {
            document.body.classList.remove('animation-speed-0');
          }
        }
      });
    }

    // Capture interactive components state that we want to preserve
    // (quantity, accordions, personalization inputs, etc.)
    // Excludes anything inside product-high-variants, which should always come from new HTML
    captureInteractiveState() {
      const state = {
        quantity: null,
        accordions: {},
        tabs: {},
        fields: {},
        customValues: {},
        customPersonalizationFormSelectionId: null
      };

      if (!this.mainElement) {
        return state;
      }

      const info = this.mainElement.querySelector('.main-product-info');
      if (!info) {
        return state;
      }

      state.customValues.requiredOptions = this.mainElement.requiredOptions;

      // Quantity - only if not inside product-high-variants
      const qtyInput = info.querySelector('.quantity-input.is-main-input');
      if (qtyInput && !qtyInput.closest('product-high-variants')) {
        state.quantity = qtyInput.value;
      }

      // Accordions (including enhanced description) - only if not inside product-high-variants
      info.querySelectorAll('.accordion').forEach((acc)=>{
        // Skip accordions inside product-high-variants
        if (acc.closest('product-high-variants')) {
          return;
        }
        const panel = acc.querySelector('.accordion-panel');
        const trigger = acc.querySelector('.accordion-trigger');
        if (!panel) return;
        const panelId = panel.id || null;
        if (!panelId) return;
        const isOpen = acc.classList.contains('open') ||
          (trigger && trigger.getAttribute('aria-expanded') === 'true');
        state.accordions[panelId] = { open: isOpen };
      });

      info.querySelectorAll('util-tabs[id]').forEach((tab)=>{
        state.tabs[tab.id] = tab.activeTabIndex();
      });

      // "No personalization" vs addon radios — not under .personalize-field (see custom_personalization_form)
      const personalizeFormToggle = info.querySelector('input[name="custom-personalization-form"]:checked');
      if (personalizeFormToggle && !personalizeFormToggle.closest('product-high-variants') && personalizeFormToggle.id) {
        state.customPersonalizationFormSelectionId = personalizeFormToggle.id;
      }

      // Personalization inputs / other inputs where it makes sense to preserve the value
      // Exclude anything inside product-high-variants
      info.querySelectorAll(
        '[data-preserve-state], .personalize-field input, .personalize-field textarea, .personalize-field select'
      ).forEach((el)=>{
        // Skip elements inside product-high-variants
        if (el.closest('product-high-variants')) {
          return;
        }
        // Radio groups share the same name; use id so each input's checked state is preserved
        let key = el.id || el.name;
        if (el.type === 'radio' && el.id) {
          key = el.id;
        }
        if (!key) return;
        const entry = state.fields[key] || {};

        if (el.tagName === 'SELECT') {
          entry.value = el.value;
        } else if (el.type === 'checkbox' || el.type === 'radio') {
          entry.checked = el.checked;
        } else {
          entry.value = el.value;
        }

        state.fields[key] = entry;
      });

      return state;
    }

    // Restore captured state into the new DOM, only where equivalent components exist
    // Excludes anything inside product-high-variants, which should always come from new HTML
    restoreInteractiveState(mainElement, state) {
      if (!mainElement || !state) return;

      const info = mainElement.querySelector('.main-product-info');
      if (!info) return;

      mainElement.requiredOptions = state.customValues.requiredOptions;

      // Quantity - only restore if not inside product-high-variants
      if (state.quantity !== null) {
        const qtyInput = info.querySelector('.quantity-input.is-main-input');
        if (qtyInput && !qtyInput.closest('product-high-variants')) {
          qtyInput.value = state.quantity;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      // Accordions - restore open/closed state where panel IDs match (best-effort matching)
      // Only restore accordions that are not inside product-high-variants
      Object.keys(state.accordions || {}).forEach((panelId)=>{
        const saved = state.accordions[panelId];
        const panel = info.querySelector('#'+CSS.escape(panelId));
        if (!panel) return;
        // Skip if accordion is inside product-high-variants
        if (panel.closest('product-high-variants')) {
          return;
        }
        const acc = panel.closest('.accordion');
        const trigger = info.querySelector('[aria-controls="'+panelId+'"]');
        if (!acc) return;

        if (saved.open) {
          acc.classList.add('open');
          panel.classList.add('expandable-default-open');
          if (trigger) {
            trigger.setAttribute('aria-expanded', 'true');
          }
        } else {
          acc.classList.remove('open');
          panel.classList.remove('expandable-default-open');
          if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
          }
        }
      });

      // Tabs - restore active tab where panel IDs match
      Object.keys(state.tabs || {}).forEach((panelId)=>{
        const saved = state.tabs[panelId];
        const utilTab = info.querySelector('util-tabs#'+CSS.escape(panelId));
        if (!utilTab) return;
        utilTab.activateTabByIndex(saved);
        utilTab.refresh();
      });

      // No personalization vs addon selection (must run before field restore so name attributes match selection)
      if (state.customPersonalizationFormSelectionId) {
        const toggle = info.querySelector(`#${CSS.escape(state.customPersonalizationFormSelectionId)}`);
        if (toggle && toggle.name === 'custom-personalization-form' && !toggle.closest('product-high-variants')) {
          toggle.checked = true;
          toggle.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: { loadingState: true } }));
        }
      }

      // Other fields (personalization, etc.) - only restore if not inside product-high-variants
      // Do not use CSS.escape() inside [name="..."]: it escapes [] and breaks Shopify property names like properties[Foo]
      const findPreservedFieldElements = (root, key) => {
        const set = new Set();
        const byId = root.querySelector(`#${CSS.escape(key)}`);
        if (byId) {
          set.add(byId);
          return set;
        }
        root.querySelectorAll('[name]:not([id])').forEach((el) => {
          if (el.name === key) set.add(el);
        });
        root.querySelectorAll('[data-field-name]:not([id])').forEach((el) => {
          if (el.getAttribute('data-field-name') === key) set.add(el);
        });
        root.querySelectorAll('[data-name]:not([id])').forEach((el) => {
          if (el.getAttribute('data-name') === key) set.add(el);
        });
        return set;
      };

      Object.keys(state.fields || {}).forEach((key)=>{
        const fieldState = state.fields[key];
        const candidates = findPreservedFieldElements(info, key);
        candidates.forEach((el)=>{
          // Skip if field is inside product-high-variants
          if (el.closest('product-high-variants')) {
            return;
          }
          if (el.tagName === 'SELECT') {
            if (typeof fieldState.value !== 'undefined') {
              el.value = fieldState.value;
              el.dispatchEvent(new Event('change', { bubbles: true }));
            }
          } else if (el.type === 'checkbox' || el.type === 'radio') {
            if (typeof fieldState.checked !== 'undefined') {
              el.checked = fieldState.checked;
              el.dispatchEvent(new Event('change', { bubbles: true }));
            }
          } else if (typeof fieldState.value !== 'undefined') {
            el.value = fieldState.value;
            el.dispatchEvent(new Event('input', { bubbles: true }));
          }
        });
      });
    }

  }
  customElements.define('product-high-variants', ProductHighVariants);
}

if(!customElements.get('product-variant-edit')) {
  class ProductVariantEdit extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.toggles = this.querySelectorAll('.toggle');
      this.toggles.forEach(btn=>{btn.addEventListener('click', this.onToggle.bind(this))});
      this.editing = false;
    }
    onToggle() {
      this.editing = !this.editing;
      var divVariants = this.querySelector('.variants');
      var divInfo = this.querySelector('.info');
      if (this.editing) {
        $s.expand([divVariants]);
        this.toggles.forEach(btn=>{btn.classList.add('open')});
      } else {
        $s.collapse([divVariants]);
        this.toggles.forEach(btn=>{btn.classList.remove('open')});
      }
    }
  }
  customElements.define('product-variant-edit', ProductVariantEdit);
}

if(!customElements.get('product-swatch')) {
  class ProductSwatch extends HTMLElement {
    constructor() {
      super();
      this.colorSwatchesOptions = ["Color"]
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      this.trimOptionsLimit = this.dataset.trimOptionsLimit ? parseInt(this.dataset.trimOptionsLimit) : null;
      this.swatchTooltip = this.dataset.swatchTooltip === 'true';
      this.setAttribute('aria-labelledby', `swatchgroup-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`);

      this.buildOptionSelector();
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber - 1];
      var defaultValue = currentVariant.options[this.optionNumber-1];
      var optionElement = document.createElement('div');
      var mainElementId = this.mainElement.dataset.productId;
      var optionNameHandle = $s.handleize(this.label);
      const isProductCardAtc = this.mainElement.classList.contains('product-card') && this.mainElement.classList.contains('atc');
      const optionNameClass = isProductCardAtc ? ' class="visually-hidden"' : '';
      var html = `
        <div class="option-name">
          <span id="${this.getAttribute('aria-labelledby')}"${optionNameClass}>${this.label}: </span>
          <span aria-hidden="true" class="option-value">${defaultValue}</span>
        </div>
        <div class="swatch-group flex flex-wrap"></div>
      `;
      this.innerHTML = html;
      this.buildOptions(optionValues, defaultValue);
    }

    buildOptions(options, defaultValue) {
      var html = '';
      if (options.length > 0) {
        this.setAttribute('role', 'radiogroup');
      }
      const isInteractive = !this.closest('[aria-hidden="true"]');
      options.forEach((option, index)=>{
        var optionNameHandle = $s.handleize(this.label);
        var optionValueHandle = $s.handleize(option.value);
        var id = `swatch2-${this.optionNumber}-${$s.handleize(option.value)}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`;
        var soldOut = (!option.available ? '<span class="visually-hidden"> ('+lngg.product_main__sold_out_message+')</span>' : '');

        if (!this.trimOptionsLimit || index < this.trimOptionsLimit) {
          const isColorSwatch = this.colorSwatchesOptions.indexOf(this.label) > -1;
          const swatchNameStyle = isColorSwatch && this.swatchTooltip
            ? ` style="--swatch-name: ${$s.escapeDomAttribute(JSON.stringify(option.value))}"`
            : '';
          html += `
            <div class="swatch" data-available="${option.available}"${swatchNameStyle}>
              <input type="radio" id="${id}" name="swatch-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}" value="${$s.escapeDomAttribute(option.value)}" ${!isInteractive ? 'tabindex="-1"':''} />
              <label for="${id}">
                <div class="label-inner flex align-items-center justify-content-center animation ${isColorSwatch ? 'color-'+optionValueHandle : ''} ${optionNameHandle}-${optionValueHandle}" ${option.isSwatch && option.color ? `style="--swatch-color: ${option.color}"` : ''}>
                  <span>${option.value}${soldOut}</span>
                  ${option.isSwatch && option.image ? `<img loading="lazy" width="80" height="80" alt="" src="${option.image}">` : ''}
                </div>
              </label>
            </div>
          `;
        } else if (index === this.trimOptionsLimit) {
          html += `<div class="swatch swatch-remaining">+${options.length - this.trimOptionsLimit} ${lngg.product_card__swatches_more}</div>`;
        }
      });
      var group = this.querySelector('.swatch-group');
      group.innerHTML = html;

      if (this.required()) {
        this.setAttribute('data-required', 'true');
        group.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
        }, {once: true})
      } else {
        this.setAttribute('data-required', 'false');
        if(defaultValue && group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]')) {
          group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]').checked = true;
        } else {
          group.querySelector('input').checked = true;
        }
      }
    }
  }
  customElements.define('product-swatch', ProductSwatch);
}

if(!customElements.get('product-dropdown')) {
  class ProductDropdown extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;

      this.buildOptionSelector();

      if (this.required()) {
        var select = this.querySelector('select');
        this.setAttribute('data-required', 'true');
        select.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
          select.querySelector('[disabled]').remove();
        }, {once: true})
      }
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];

      var optionId = 's-' + this.mainElement.sectionId+'-option-'+this.optionNumber + '-' + this.variantsElement.instanceIndex;
      var optionElement = document.createElement('div');
      const isInteractive = !this.closest('[aria-hidden="true"]');
      var html = `
        <label class="option-name" for="${optionId}">
          ${this.label}:
        </label>
        <div class="field">
          <svg aria-hidden="true" class="icon icon-arrow-down" viewBox="0 0 32 32"><path class="stroke" d="M27,10,16,22,5,10"/></svg>
          <select id="${optionId}" name="swatch-${optionId}" ${!isInteractive ? 'tabindex="-1"':''}></select>
        </div>
      `;
      this.innerHTML = html;
      this.buildOptions(optionValues, defaultValue);
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptions(options, defaultValue) {
      var html = '';
      if (this.required()) {
        html += `<option value="${defaultValue || ''}" disabled selected>${lngg.general__forms__select_option_label}</option>`;
      } else {
        this.setAttribute('data-required', 'false');
      }
      options.forEach((option, index)=>{
        html += `<option value="${$s.escapeDomAttribute(option.value)}">${option.value}</option>`;
      });
      var select = this.querySelector('select');
      select.innerHTML = html;

      if(defaultValue) {
        var newValueIndex = Array.from(select.options).findIndex(x=>x.value==defaultValue);
        if(newValueIndex>=0) {
          select.selectedIndex = newValueIndex;
        }
      }
    }
  }
  customElements.define('product-dropdown', ProductDropdown);
}

if(!customElements.get('product-model')) {
  class ProductModel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = document.querySelector('.product-main-element[data-product-id="'+this.dataset.productId+'"]');

      window.Shopify.loadFeatures([{
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXr.bind(this)
      }]);
    }

    setupShopifyXr() {
      if(!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', ()=>{
          this.setupShopifyXr();
        });
      } else {
        window.ShopifyXR.addModels(this.mainElement.productData.media.filter(x=>x.media_type=='model'));
        setTimeout(()=>{
          window.ShopifyXR.setupXRElements();
        }, 100);
      }
    }
  }
  customElements.define('product-model', ProductModel);
}

if(!customElements.get('product-sticky-panel')) {
  class ProductStickyPanel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.scrollHandler = $s.throttle(this.onScroll.bind(this), 50);
      this.updateRefsHandler = this.updateRefs.bind(this);
      this.updateRefs();
    }

    connectedCallback() {
      if (this.positionElement) {
        window.addEventListener('scroll', this.scrollHandler);
        this.mainElement.addEventListener('variantChange', this.updateRefsHandler);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.scrollHandler);
      this.mainElement.removeEventListener('variantChange', this.updateRefsHandler);
    }

    updateRefs() {
      this.positionElement = this.mainElement.querySelector('.product-sticky-panel-position-placeholder');
    }

    onScroll(event) {
      if (this.mainElement?.dataset?.replacingInfo === 'true') return;
      if (!this.positionElement) return;
      var bounds = this.positionElement.getBoundingClientRect();
      if (bounds.bottom < 0) {
        if (!this.showing) {
          this.classList.add('open');
          this.showing = true;
        }
      } else {
        if (this.showing) {
          this.classList.remove('open');
          this.showing = false;
        }
      }

    }

  }
  customElements.define('product-sticky-panel', ProductStickyPanel);
}

if(!customElements.get('pickup-availability')) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this._boundOnVariantChange = this._boundOnVariantChange || this.onVariantChange.bind(this);
    }

    connectedCallback() {
      if (this.mainElement && this._boundOnVariantChange) {
        this.mainElement.addEventListener('variantChange', this._boundOnVariantChange);
      }
    }

    disconnectedCallback() {
      if (this.mainElement && this._boundOnVariantChange) {
        this.mainElement.removeEventListener('variantChange', this._boundOnVariantChange);
      }
    }

    onVariantChange(e) {
      if(e.detail.variant && e.detail.variant.available) {
        this.fetchAvailability(e.detail.variant.id);
      } else {
        this.innerHTML = '';
      }
    }

    fetchAvailability(variantId) {
      let rootUrl = routes.root_url;
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup_availability`;

      $s.get({
        url: variantSectionUrl,
        success: (data)=>{
          this.innerHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('.shopify-section').innerHTML;
          this.bindEvents();
        },
        error: ()=>{
          this.innerHTML = '';
        }
      });
    }

    bindEvents() {
      let button = this.querySelector('.pickup-popup-trigger');
      if(button) {
        button.addEventListener('click', ()=>{
          $s.openModal(this.querySelector('.pickup-availability-info'), 'pickup-availability-info-modal');
        });
      }
    }
  }
  customElements.define('pickup-availability', PickupAvailability);
}






